const toggleTriggers = document.getElementsByClassName('js-click-toggle');
const toggleLightboxes = document.getElementsByClassName('js-click-lightbox');
const toggleMobileTriggers = document.getElementsByClassName('js-click-mobile');
const lightboxClip = document.querySelector('.js-video');

function initToggles() {
  // Multi purpose for general toggles of CSS states
  for (let i = toggleTriggers.length - 1; i >= 0; i -= 1) {
    toggleTriggers[i].addEventListener('click', event => {
      event.preventDefault();
      toggleTriggers[i].classList.toggle('js-active');
    });
  }

  // Active the lightbox on click and start video
  for (let i = toggleLightboxes.length - 1; i >= 0; i -= 1) {
    toggleLightboxes[i].addEventListener('click', event => {
      event.preventDefault();

      // Set video source on clips coming from background media menu template
      if (toggleLightboxes[i].dataset.clip) {
        lightboxClip.setAttribute('src', toggleLightboxes[i].dataset.clip);
      }

      // Use class to hide display regardless where it sits on the document
      document
        .getElementsByTagName('body')[0]
        .classList.toggle('js-active-lightbox');

      // Check if open or close request, and act accordingly so user doesn't need to click twice
      if (toggleLightboxes[i].classList.contains('js-click-lightbox--open')) {
        lightboxClip.play();
      }

      if (toggleLightboxes[i].classList.contains('js-click-lightbox--close')) {
        lightboxClip.pause();
      }
    });
  }

  // Multi purpose for general toggles of CSS states
  for (let i = toggleMobileTriggers.length - 1; i >= 0; i -= 1) {
    toggleMobileTriggers[i].addEventListener('click', event => {
      if (window.innerWidth <= 1024) {
        event.preventDefault();
        toggleMobileTriggers[i].classList.toggle('js-active');
      }
    });
  }
}

export default initToggles;



// WEBPACK FOOTER //
// ./src/scripts/modules/toggles.js